import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

// LA RISPOSTA DI UNA LISTA VUOTA, non un pannello bianco: il glifo dice di che lista si tratta e la
// riga dice cosa farci. È la stessa forma che il Composer dà ai suoi vuoti, così passando da una
// stanza all'altra il vuoto si legge allo stesso modo.
const Box = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 32px 28px;
    color: ${(props) => props.theme.app.primary};
    text-align: center;

    p {
        max-width: 34ch;
        margin: 0;
        font-size: 13px;
        line-height: 1.6;
    }

    svg {
        width: 26px;
        height: 26px;
        opacity: 0.5;
    }
`;

export const SceneEmptyState: FC<{ icon?: ReactNode; children?: ReactNode }> = ({ icon, children }) => (
    <Box>
        {icon}
        <p>{children}</p>
    </Box>
);

export default SceneEmptyState;
